/**
 * AUT-396 (CP-01) — company (`orgs`) wire contract: admin SPA (CP-10b), picker
 * app (CP-04 `PickerOrgDto`), report brand (CP-06 `OrgBrandDto`).
 */
export const ORG_STATUSES = ['active', 'suspended', 'terminated'];
/** AUT-536 (SM-03): who created the company — an admin (legal entity) or a specialist profile's team. */
export const ORG_SOURCES = ['admin', 'self'];
/** Text + CHECK in the DB, so `dispatcher` / `accountant` can join later. */
export const ORG_MEMBER_ROLES = ['owner', 'member'];
export const ORG_MEMBER_STATUSES = ['active', 'removed'];
export const ORG_MEMBER_REMOVED_REASONS = [
    'owner',
    'self',
    'admin',
    'account_deleted',
    'org_terminated',
];
/** `POST /admin/orgs/:id/status` actions. */
export const ORG_STATUS_ACTIONS = ['suspend', 'reinstate', 'terminate'];
export const ORG_LOGO_CONTENT_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
/**
 * AUT-403 (CP-10b) — the limits the API's create / update schemas enforce,
 * shared so the admin form validates the same way before it sends.
 */
/** New companies get this many seats unless the admin says otherwise. */
export const ORG_DEFAULT_MAX_MEMBERS = 10;
export const ORG_MAX_MEMBERS_CAP = 500;
/** Confirm refuses a bigger object (S3 does not sign Content-Length). */
export const ORG_LOGO_MAX_BYTES = 2 * 1024 * 1024;
export const ORG_NAME_MAX = 120;
export const ORG_LEGAL_NAME_MAX = 200;
export const ORG_CITY_MAX = 80;
export const ORG_SITE_MAX = 200;
export const ORG_STATUS_REASON_MAX = 500;
/** 9 digits — the Belarusian УНП. */
export const ORG_UNP_PATTERN = /^\d{9}$/;
/** УНП check-digit weights for the first 8 digits. */
const UNP_WEIGHTS = [29, 23, 19, 17, 13, 7, 5, 3];
const UNP_MOD = 11;
const UNP_INVALID_REMAINDER = 10;
/** Strips all whitespace; an empty result is `null`. */
export function normalizeUnp(raw) {
    const s = raw.replace(/\s+/g, '');
    return s === '' ? null : s;
}
/** 9 digits and the 9th is the weighted mod-11 check digit of the first 8. */
export function isValidUnp(s) {
    if (!ORG_UNP_PATTERN.test(s))
        return false;
    const sum = UNP_WEIGHTS.reduce((acc, w, i) => acc + w * Number(s[i]), 0);
    const check = sum % UNP_MOD;
    return check !== UNP_INVALID_REMAINDER && check === Number(s[8]);
}
/** `+375291234567`-style; digits only after an optional `+`. */
export const ORG_PHONE_PATTERN = /^\+?\d{7,15}$/;
/** A Telegram username, with or without `@`. */
export const ORG_TELEGRAM_PATTERN = /^@?[A-Za-z0-9_]{5,32}$/;
/**
 * AUT-402 (CP-05) — the short public form of a person's name: «Иван К.»
 * (owner decision 6). First name + the first letter of the last name;
 * the first name alone without a last name; `null` without a first name
 * (the client renders its own placeholder — rule #11). Pure, trims.
 */
export function personByline(firstName, lastName) {
    const first = firstName?.trim() ?? '';
    if (first === '')
        return null;
    const initial = Array.from(lastName?.trim() ?? '')[0];
    return initial === undefined ? first : `${first} ${initial.toUpperCase()}.`;
}
//# sourceMappingURL=org.js.map